import { render } from "./detail-ursa.vue?vue&type=template&id=1c8cd46b&scoped=true&ts=true"
import script from "./detail-ursa.vue?vue&type=script&lang=ts"
export * from "./detail-ursa.vue?vue&type=script&lang=ts"

import "./detail-ursa.vue?vue&type=style&index=0&id=1c8cd46b&scoped=true&lang=css"
import "./detail-ursa.vue?vue&type=style&index=1&id=1c8cd46b&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8cd46b"]])

export default __exports__